import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#10b981',
        secondary: '#f4f8f9',
        grey: '#bcbcbc',
        accent: '#8E2DE2',
        accent2: '#363840',
        error: '#F44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#4caf50'
      }
    }
  },
  icons: {
    iconfont: 'fa'
  }
});
